import { connect } from 'react-redux';

import { StoreState } from '../../redux/reducers/store.types';

import { getOperationGroupsList } from './operation-groups/operation-groups.selectors';
import { OperationPanel } from './operation-panel';

const mapStateToProps = (state: StoreState) => ({
  operationGroupsList: getOperationGroupsList(state),
});

export const OperationPanelContainer = connect(mapStateToProps)(OperationPanel);
